import { Grid, useTheme } from "@mui/material";
import { ArticleItems } from "./index";

export default function RandomNews({ news }) {
  const theme = useTheme();

  return (
    <Grid
      container
      columnSpacing={{ md: 2, lg: 5.5 }}
      sx={{
        mb: "100px",
        [theme.breakpoints.down("md")]: {
          px: "16px",
          my: "20px",
          ":not(:last-of-type)": {
            borderBottom: "1px solid #e6e6e7",
          },
        },
      }}
    >
      {(news?.data || []).map(news => (
        <Grid
          item
          key={news.id}
          xs={12}
          md={6}
          sx={{
            [theme.breakpoints.down("md")]: {
              ":not(:last-of-type)": {
                borderBottom: "1px solid #e6e6e7",
              },
            },
          }}
        >
          <ArticleItems {...news} date={true} />
        </Grid>
      ))}
    </Grid>
  );
}
